import Product from "@/api/Product";
import OrderItemOption from "@/api/OrderItemOption";

export class OrderItemDTO {
    id?: number;
    options?: OrderItemOption[];
    price = 0;
    qty = 1;
    total = 0;
    product?: Product;
}

export default class OrderItem extends OrderItemDTO {
    constructor(dto: OrderItemDTO) {
        super();
        Object.assign(this, dto);
        if (this.product != undefined) {
            this.product = new Product(this.product);
        }
    }
}